<template>
  <div
    ref="wrapper"
    @mousemove="move"
    @mouseenter="zoom"
    @mouseleave="unzoom"
    class="iz-ImageZoom_Wrapper"
  >
    <img
      ref="baseImage"
      :class="image_class"
      :src="base_image"
      :alt="alt"
      class="iz-ImageZoom_BaseImage"
    />
    <img
      ref="zoomImage"
      v-if="active && zoom_image"
      :src="zoom_image || base_image"
      :alt="alt"
      class="iz-ImageZoom_ZoomImage"
    />
  </div>
</template>

<script>
export default {
  name: "ImageZoomer",
  props: {
    base_image: {
      required: true,
      type: String,
    },
    zoom_image: {
      default: "",
      type: String,
    },
    alt: {
      required: true,
      type: String,
    },
    image_class: {
      default: "",
      type: String,
    },
    active: {
      type: Boolean,
    },
  },
  methods: {
    zoom() {
      if (this.showZoomImage()) {
        this.$refs.zoomImage.style.opacity = 1;
        this.$refs.baseImage.style.opacity = 0;
      }
    },
    unzoom() {
      if (this.showZoomImage()) {
        this.$refs.zoomImage.style.opacity = 0;
        this.$refs.baseImage.style.opacity = 1;
      }
    },
    move(e) {
      if (!this.showZoomImage()) {
        return false;
      }

      function pageOffset(el) {
        var rect = el.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
          y: rect.top + scrollTop,
          x: rect.left + scrollLeft,
        };
      }

      let offset = pageOffset(this.$el);
      let zoom = this.$refs.zoomImage;
      let wrapper = this.$refs.wrapper;
      let relativeX = e.clientX - offset.x + window.pageXOffset;
      let relativeY = e.clientY - offset.y + window.pageYOffset;
      let baseFactorX = relativeX / wrapper.offsetWidth;
      let baseFactorY = relativeY / wrapper.offsetHeight;
      let x = baseFactorX * (zoom.offsetWidth - wrapper.offsetWidth);
      let y = baseFactorY * (zoom.offsetHeight - wrapper.offsetHeight);
      zoom.style.transform = `translate3D(${-x}px, ${-y}px, 0)`;
    },
    showZoomImage() {
      if (!this.$refs.zoomImage) {
        return false;
      }

      return this.$refs.zoomImage.naturalWidth > this.$refs.baseImage.naturalWidth * 1.2;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.iz-ImageZoom_Wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iz-ImageZoom_BaseImage {
  max-width: 100%;
  background: $white;
  border-radius: $border-radius;
  cursor: pointer;
  padding: $spacer-2;

  @media (min-width: $screen-md-min) {
    padding: $spacer-3;
  }
}

.iz-ImageZoom_Wrapper .iz-ImageZoom_BaseImage {
  max-width: 100%;
  border-radius: $border-radius;
}

.iz-ImageZoom_Wrapper .iz-ImageZoom_ZoomImage {
  border-radius: $border-radius;
  position: absolute;
  background: $white;
  opacity: 0;
  transform-origin: top left;
  max-width: 300%;
  transition: opacity $transition-duration-short;
  left: 0;
  top: 0;
  will-change: transform;
}
</style>
